// JsFromRoutes CacheKey b3119cc84af2014e468cdff690f022b4
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@/utils/definePathHelper'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '(/:locale)/profiles/:profile_username/builds'),
}
